import { createContext } from 'react';

const MenuContext = createContext({
    tribuSelected: "nantes",
    setTribuSelected: (tribu) => { }
}
);

export { MenuContext }